import React, { useMemo } from 'react';
import Proptypes from 'prop-types';
import CheckIcon from './CheckIcon';
import { StyledCheck } from './StyledCheck';

const StyledCheckbox = ({
  value,
  onChange,
  label,
  disabled,
  size,
  className,
  ...props
}) => {
  const id = useMemo(() => `checkbox-${Math.random()}`, []);
  const onChangeCheckbox = (event) => {
    if (onChange) {
      onChange(event);
    }
  };
  return (
    <>
      <label
        htmlFor={id}
        className={`d-flex align-items-center mb-0 mr-1 mr-sm-4 ${className}`}
        style={{ cursor: 'pointer' }}
      >
        <StyledCheck
          value={value}
          height={size}
          width={size}
          size={size}
          {...props}
        >
          {value && <CheckIcon size="10px" />}
        </StyledCheck>
        {label && <span className="ms-2 text-nowrap text-black">{label}</span>}
      </label>
      <input
        id={id}
        type="checkbox"
        style={{ display: 'none' }}
        checked={value}
        disabled={disabled}
        onChange={onChangeCheckbox}
      />
    </>
  );
};

StyledCheckbox.propTypes = {
  value: Proptypes.bool,
  onChange: Proptypes.func,
  label: Proptypes.string,
};

export default StyledCheckbox;
